defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/PlayersList',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Avatar',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, Utils, Avatar, CtaButton) {
    var iconsPath = '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg';

    var PlayersList = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.playersSectionDictionary = this.rootDictionary.get.bind({ prefix: 'ViewCoupon/PlayersSection/' });

        this.players = this.play.playerFundingSummaries.map((fundingPlayer) => {
          var player = this.clubModel().getPlayerById(fundingPlayer.playerId);
          if (!player) {
            return {
              name: 'unknown',
              playerId: fundingPlayer.playerId,
              rowCount: fundingPlayer.rowCount,
              stakeAmount: fundingPlayer.stakeAmount,
              stakePercentageOfGroupPlay: fundingPlayer.stakePercentageOfGroupPlay
            };
          }
          return {
            playerId: player.playerId,
            name: player.name,
            rowCount: fundingPlayer.rowCount,
            stakeAmount: fundingPlayer.stakeAmount,
            stakePercentageOfGroupPlay: fundingPlayer.stakePercentageOfGroupPlay
          };
        });
        this.chairmanId = m.prop(this.clubModelFields().chairman().playerId);

        this.withMorePlayers = this.players.length > 4;
        this.allPlayersShown = m.prop(false);
        this.toggleShowMore = () => {
          this.allPlayersShown(!this.allPlayersShown());
        };

        this.listConfig = ($element) => {
          if (!this.withMorePlayers) {
            return;
          }

          const $innerWrapper = $element.querySelector('.play-together-coupon-players-list__items-wrapper');

          if (this.allPlayersShown()) {
            $element.style.maxHeight = $innerWrapper.offsetHeight + 'px';
          } else {
            $element.style.maxHeight = null;
          }
        };
      },
      view: function (controller) {
        var playerItem = function (player) {
          return m('.player-item', [
            Avatar({
              name: player.name == 'unknown' ? '!' : player.name,
              isChairman: player.playerId === controller.chairmanId()
            }),
            m('.player-item__details', [
              m('.player-name', player.name == 'unknown' ? controller.playersSectionDictionary('PlayerItem/UnknownPlayer') : player.name),
              m('.play-details', [
                // player rows
                m('.play-details__item', [
                  m('svg.play-details__item-icon', [
                    m('use', { href: iconsPath + '#card_with_rows_tilted' })
                  ]),
                  m('.play-details__text', m.trust(
                    controller.playersSectionDictionary('PlayerItem/RowsLabel', { count: player.rowCount / controller.play.numberOfDraws })
                  ))
                ]),
                // player stake amount
                m('.play-details__item', [
                  m('svg.play-details__item-icon', [
                    m('use', { href: iconsPath + '#coins' })
                  ]),
                  m('.play-details__text', m.trust(
                    controller.playersSectionDictionary('PlayerItem/DepositLabel', { amount: Utils.formatCurrency(player.stakeAmount) })
                  ))
                ]),
                // player stake percentage
                m('.play-details__item.total', [
                  m('.play-details__text', [
                    m('strong', player.stakePercentageOfGroupPlay + '%')
                  ])
                ])
              ])
            ])
          ]);
        };
        // View:
        return m('.play-together-coupon-players-section', [
          m('.play-together-coupon-players-list', {
            config: controller.listConfig,
            class: controller.withMorePlayers ? 'players-list__collapsable' : ''
          }, [controller.players.length > 0 ? [
            m('.play-together-coupon-players-list__items-wrapper',
              controller.players.map(function (player) {
                return playerItem(player);
              })
            )
          ] : m('.play-together-coupon-players-list__empty', controller.playersSectionDictionary('NoPlayers'))
          ]),
          controller.withMorePlayers ? m('.players-list__show-all-players', CtaButton({
            text: controller.playersSectionDictionary(controller.allPlayersShown() ? 'ShowLessButton' : 'ShowAllButton'),
            onClick: controller.toggleShowMore,
            options: ['small']
          })) : null
        ]);
      }
    };

    // Public functions:
    return PlayersList;
  });
